import React from 'react';
import { useReveal } from '../lib/useReveal';
const TESTIMONIALS = [{
  initials: 'CR',
  name: 'Cecilia R.',
  location: 'Mendoza',
  text: '"El Tomo 4 — Símbolos y Reiki a Distancia — me abrió un mundo nuevo. Mi primera sesión a distancia fue mágica. Los dos sentimos la energía."'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  location: 'La Plata',
  text: '"El Tomo 5 de Reiki Profesional y Salida Laboral me dio todo lo que necesitaba para cobrar lo que vale mi trabajo sin bajar la voz."'
}, {
  initials: 'PA',
  name: 'Paula A.',
  location: 'Neuquén',
  text: '"El Reiki de Bolsillo fue lo que me mantuvo constante el primer mes. Lo tenía siempre a mano y eso me ayudó a no abandonar como siempre."'
}, {
  initials: 'JM',
  name: 'Julia M.',
  location: 'Rosario',
  text: '"El Tomo 6 — Maestría Reiki y Expansión Espiritual — me dio una claridad que no esperaba. Sentí que finalmente integraba todo."'
}];
export function MoreTestimonialsSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#faf5fc] py-12 md:py-16 px-5 sm:px-6 border-t border-[#e8d5f0]" data-id="element-270">
      <div className="container mx-auto max-w-5xl" data-id="element-271">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-272">
          <h2 className="text-2xl md:text-4xl font-bold text-[#3d2a5f] mb-4" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-273">
            ❤️ MÁS PERSONAS QUE YA LO TIENEN
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-274">
          {TESTIMONIALS.map((t, idx) => <div key={idx} className="bg-white border border-[#e8d5f0] rounded-2xl p-6 flex flex-col shadow-sm" data-id="element-275">
              <div className="flex items-center gap-3 mb-4" data-id="element-276">
                <div className="w-10 h-10 rounded-full bg-[#f3e9f7] border border-[#e8d5f0] flex items-center justify-center text-[#3d2a5f] font-bold text-sm" data-id="element-277">
                  {t.initials}
                </div>
                <div data-id="element-278">
                  <div className="flex text-[#c9a14d] text-sm mb-0.5" data-id="element-279">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <p className="text-[#3d2a5f] font-bold text-sm" data-id="element-280">
                    {t.name}{' '}
                    <span className="text-[#6b5a85] font-normal" data-id="element-281">
                      — {t.location}
                    </span>
                  </p>
                </div>
              </div>
              <p className="text-[#6b5a85] text-sm leading-relaxed italic" data-id="element-282">
                {t.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}